import type { StripeElements } from '@stripe/stripe-js';

import type {
  SupportedStripeElement,
  SupportedStripeElementType,
} from '../StripeInput';

/**
 * Safely get an element by only allowing the valid element types allowed by
 * this module
 */
export function getStripeElement<TType extends SupportedStripeElementType>(
  elements: StripeElements,
  type: TType
): SupportedStripeElement<TType> | null {
  switch (type) {
    case 'cardNumber': {
      return elements.getElement(type) as SupportedStripeElement<TType>;
    }
    case 'cardCvc': {
      return elements.getElement(type) as SupportedStripeElement<TType>;
    }
    case 'cardExpiry': {
      return elements.getElement(type) as SupportedStripeElement<TType>;
    }
    default: {
      return null;
    }
  }
}
